// QA switches read from the page URL (the /__mocks gallery and manual checks):
//   ?motion=off  every mock renders its final frame, as under reduced motion
//   ?mock=final  same, kept separate so a QA link says what it is checking
//   ?step=N      every mock holds still at step N (screenshots of a mid-frame)
//   ?plate=off   hides the backdrop plate behind mocks (site/Sections.jsx)
const readFlags = () => {
  if (typeof window === 'undefined') return { final: false, step: null, plate: null };
  const params = new URLSearchParams(window.location.search);
  const step = params.get('step');
  return {
    final: params.get('motion') === 'off' || params.get('mock') === 'final',
    step: step === null ? null : Math.max(0, Number(step) || 0),
    plate: params.get('plate'),
  };
};

export const mockFlags = readFlags();
